import React from 'react';
import { Box } from '@mui/material';
import { Label } from '../';
import './Tabs.css';

export interface Tab {
  key: string;
  label: string;
  badgeCount?: number;
}

export interface TabsProps {
  /**
   * Array of tabs
   */
  tabs: Tab[];
  
  /**
   * Active tab key
   */
  activeTab: string;
  
  /**
   * Callback when tab is clicked
   */
  onTabChange: (tabKey: string) => void;
  
  /**
   * Additional className
   */
  className?: string;
}

const Tabs: React.FC<TabsProps> = ({
  tabs,
  activeTab,
  onTabChange,
  className = '',
}) => {
  return (
    <Box className={`tabs-container ${className}`}>
      {tabs.map((tab) => {
        const isActive = tab.key === activeTab;
        
        return (
          <Box
            key={tab.key}
            onClick={() => onTabChange(tab.key)}
            className={`tab ${isActive ? 'active' : ''}`}
          >
            <Label
              variant="body"
              color={isActive ? 'white' : 'primary'}
            >
              {tab.label}
            </Label>
            
            {/* Badge */}
            {tab.badgeCount !== undefined && tab.badgeCount > 0 && (
              <Box className={`tab-badge ${isActive ? 'active' : ''}`}>
                {tab.badgeCount}
              </Box>
            )}
          </Box>
        );
      })}
    </Box>
  );
};

export default Tabs;
